import { useQuery } from '@tanstack/react-query'

import { getServerLikesActive } from '@wwt/core/admin'

import { dislikesOptions } from '../index.ts'

export const useDislikes = () => {
	const query = useQuery(
		dislikesOptions({
			enabled: getServerLikesActive(),
			// TODO
			// Think about this in the future and maybe add onSettled to mutations
			staleTime: 0
		})
	)

	return query
}
